export default __webpack_public_path__ + "static/adams-group-logo-840a97b0d0e3a5a85d5caa9ccbc8e42a.png";